import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Badge as BadgeMemoized } from '../../Badge/Badge.js';
import { Typography } from '../../Typography/Typography.js';

var _excluded = ["hierarchy", "label"];
var DiscountBadge = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var hierarchy = _ref.hierarchy,
    label = _ref.label,
    rest = _objectWithoutProperties(_ref, _excluded);
  if (!hierarchy || hierarchy === 'primary') {
    return /*#__PURE__*/React.createElement(BadgeMemoized, _extends({
      label: label,
      variant: "primary.price",
      ref: ref
    }, rest));
  }
  return /*#__PURE__*/React.createElement(Typography, _extends({
    variant: "caption-default",
    textColor: "product.price",
    ref: ref
  }, rest), label);
});
DiscountBadge.defaultProps = {
  hierarchy: 'primary'
};
var DiscountBadgeMemoized = /*#__PURE__*/React.memo(DiscountBadge);
DiscountBadgeMemoized.displayName = 'DiscountBadge';

export { DiscountBadgeMemoized as DiscountBadge };
//# sourceMappingURL=DiscountBadge.js.map
